import { CommandsPaletteEntry } from '../../common/data/designs.js';
import { ColorTriple, mainColorGroups } from '../../common/data/colors.js';
import { Maybe } from '../../common/data.js';

export const allowedMaskInputKinds = ['black', 'white', 'mask', 'clip', 'overlay', ...mainColorGroups] as const;
export type AllowedMaskInputKind = (typeof allowedMaskInputKinds)[number];

export interface ProductMaskGenerationAdjustment {
	brightness: number;
	shadowMul: number;
	highlightMul: number;
}

export function paintCommands(commands: Uint8Array | Uint8ClampedArray, data: Uint8ClampedArray, colors: (number[] | CommandsPaletteEntry | null)[], patterns?: Maybe<Uint8ClampedArray>[]) {
	
	let c = 0, i = 0;
	
	const rgbt: ColorTriple = [0, 0, 0];
	let rgbc = rgbt;
	let pat: Maybe<Uint8ClampedArray>;
	let fill = 1;
	const rgb = (cc: number) => pat ? pat[i + cc]! : rgbc[cc]!;
	const decc = () => {
		if (commands[c] != 31) {
			const cidx = commands[c++]! - 1;
			const col = colors[cidx];
			rgbc = (col ?? [0, 0, 0]) as ColorTriple;
			fill = col !== null ? 1 : 0;
			pat = patterns?.[cidx];
		}
		else {
			c++;
			rgbt[0] = commands[c++]!;
			rgbt[1] = commands[c++]!;
			rgbt[2] = commands[c++]!;
			rgbc = rgbt;
			pat = undefined;
			fill = 1;
		}
	};
	
	while (c < commands.length && i < data.length) {
		if (!commands[c]) {
			c++;
			i += commands[c]! * 4;
			c++;
		}
		else if (commands[c]! < 32) {
			
			decc();
			
			const ei = i + commands[c]! * 4;
			if (pat) for (; i < ei; i += 4) {
				data[i] = pat[i]!;
				data[i + 1] = pat[i + 1]!;
				data[i + 2] = pat[i + 2]!;
				data[i + 3] = 255 * fill;
			}
			else for (; i < ei; i += 4) {
				data[i] = rgbc[0];
				data[i + 1] = rgbc[1];
				data[i + 2] = rgbc[2];
				data[i + 3] = 255 * fill;
			}
			
			c++;
			
		}
		else {
			
			const n = commands[c]! - 32;
			c++;
			
			let or = 0, og = 0, ob = 0, oa = 0;
			for (let j = 0; j < n; c++, j++) {
				decc();
				if (!fill) continue;
				const a = commands[c]! / 255;
				or = a * rgb(0) + (1 - a) * or;
				og = a * rgb(1) + (1 - a) * og;
				ob = a * rgb(2) + (1 - a) * ob;
				oa = a * 255 + oa * (1 - a);
			}

			data[i] = or;
			data[i + 1] = og;
			data[i + 2] = ob;
			data[i + 3] = oa;

			i += 4;

		}
	}
	
}

export function applyMask(data: Uint8ClampedArray, mdata: Uint8ClampedArray, multiplier = 1, alpha = true) {
	for (let i = 0, l = data.length; i < l; i += 4) {
		const burn = 255 + (255 - mdata[i]!) * multiplier;
		const screen = 255 - mdata[i + 1]! * multiplier;
		data[i] = 255 - (((burn - data[i]!) * screen) >> 8);
		data[i + 1] = 255 - (((burn - data[i + 1]!) * screen) >> 8);
		data[i + 2] = 255 - (((burn - data[i + 2]!) * screen) >> 8);
		if (alpha) data[i + 3] = mdata[i + 3]!;
	}
}
